export type UserChecklistItem = {
	complete: boolean;
	text: string;
	secondaryText?: string;
	href: string;
};

export function getUserOnboardingChecklist(user: User | undefined) {
    if (!user || !user.isAuthenticated) return undefined;

    const userChecklist: UserChecklistItem[] = [
        {
            complete: user.hasMobileApp,
            text: 'Download the app and log in.',
            secondaryText: 'Apple or Android',
            href: '/download-app-redirect/',
        },
        {
            complete: user.hasSubscription,
            text: 'Get a discounted Membership.',
            secondaryText: 'View Discounts.',
            href: '/membership/',
        },
        {
            complete: user.hasMapDownload,
            text: 'Download maps for offline use.',
            secondaryText: 'Learn More.',
            href: 'https://help.gaiagps.com/hc/en-us/articles/115003525127',
        },
        {
            complete: user.hasRecordedTrack,
            text: 'Record a track.',
            secondaryText: 'Learn More.',
            href: 'https://help.gaiagps.com/hc/en-us/articles/115003525607',
        },
    ];

    return userChecklist;

}
